<template>
    <div>
        <img class="orc-img w-full" style="height: 500px;" :src=resolveURL(photos[0].attachment.url)></img>
    </div>
    <!-- TODO FIX IN FUTURE
        <el-card shadow="always" body-style="padding:0px">
        <el-carousel :interval="5000" arrow="always">
            <el-carousel-item v-for="photo in photos" :key="photo.id" class="h-full w-full">
                <img class="h-full w-full orc-img" :src="resolveURL(photo.attachment.url)" fit="cover"></el-image>
            </el-carousel-item>
        </el-carousel>
    </el-card>-->
</template>

<script>
    export default {
        props: ['branchId'],
        name: "Photos",
        watch: {
            branchId: function (newVal, val) {
                this.getPhotos()
            }
        },
        data() {
            return {
                photos: this.getPhotos(),
                resourceURL: this.$http.defaults.baseURL + 'resources'
            }
        },
        methods: {
            resolveURL(url) {
                return this.resourceURL + "/" + url
            },
            getPhotos() {
                this.$http.get(`photos?branch=${this.branchId}`).then((response) => {
                    this.photos = response.data.content;
                }).catch(function (error) {
                    this.photos = [];
                    console.log(error)
                })
            },
        }
    }
</script>

<style scoped>
.orc-img {
    mask: url("../../../assets/hero-mask-svg.png");
    mask-repeat: no-repeat;
    mask-size: contain;
    mask-position: center center;
}
</style>


// WEBPACK FOOTER //
// src/components/home/photos/Photos.vue